'use client'
import { styled } from 'styled-components'

import { Colors } from '@b-stock/fe-core/design-system'

const Wrapper = styled.div`
  background-color: ${Colors.Semantic.Neutral.white};
  border-radius: 0.5rem;
  transition: all 0.3s;
  width: 12.375rem;
  max-width: 12.375rem;
  height: 21.25rem;
  max-height: 21.25rem;
  text-decoration: none;
  overflow: hidden;
  flex-shrink: 0;
`

const BaseSkeleton = styled.div`
  border-radius: 0.25rem;
  position: relative;
  background: linear-gradient(
    270deg,
    rgba(219, 219, 219, 0.05) 0%,
    #e6e6e6 100%
  );
  animation: pulse 1s ease-in-out 0.5s infinite;
  @keyframes pulse {
    0% {
      opacity: 1;
    }

    50% {
      opacity: 0.5;
    }

    100% {
      opacity: 1;
    }
  }
`

const AuctionImageHolder = styled(BaseSkeleton)`
  height: 8.75rem;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

const ImageSkeleton = styled(BaseSkeleton)`
  width: 7.1875rem;
  height: 7.1875rem;
  max-width: 95%;
  max-height: 95%;
`

const LotInfo = styled.div`
  width: 100%;
  padding: 0.75rem;
  background-color: ${Colors.Semantic.Neutral.white};
`

const SkeletonLargeText = styled(BaseSkeleton)`
  height: 3rem;
  display: flex;
`

const SkeletonTextTypeOne = styled.div`
  margin-top: 0.5rem;
  display: flex;

  div {
    width: 6rem;
    height: 1.375rem;
    border-radius: 0.25rem;
  }
`

const SkeletonTextTypeTwo = styled(BaseSkeleton)`
  border-radius: 0.25rem;
  height: 1.625rem;
  margin-top: 0.25rem;
`

const SkeletonTextTypeThree = styled.div`
  display: flex;
  margin-top: 0.25rem;

  div {
    border-radius: 0.25rem;
    height: 1.625rem;
    width: 10rem;
  }
`

const AuctionCardSkeleton = () => {
  return (
    <Wrapper data-testid="auction-card-skeleton">
      <AuctionImageHolder data-testid="skeleton-image">
        <ImageSkeleton />
      </AuctionImageHolder>
      <LotInfo>
        <SkeletonLargeText data-testid="skeleton-large-text" />
        <SkeletonTextTypeOne>
          <BaseSkeleton data-testid="skeleton-text-1" />
        </SkeletonTextTypeOne>
        <SkeletonTextTypeOne>
          <BaseSkeleton data-testid="skeleton-text-2" />
        </SkeletonTextTypeOne>
        <SkeletonTextTypeTwo data-testid="skeleton-text-type-2" />
        <SkeletonTextTypeThree>
          <BaseSkeleton data-testid="skeleton-text-3" />
        </SkeletonTextTypeThree>
      </LotInfo>
    </Wrapper>
  )
}

export default AuctionCardSkeleton
